(function () {
    'use strict';
    angular.module('app').controller('TransitWarrantyProviderDetails', TransitWarrantyProviderDetails);
    TransitWarrantyProviderDetails.$inject = [
        'provider',
        '$uibModalInstance',
        'TransitWarrantyService',
        '$rootScope',
        'toastr'
    ];

    function TransitWarrantyProviderDetails(
        provider,
        $uibModalInstance,
        TransitWarrantyService,
        $rootScope,
        toastr
    ) {
        const vm = this;
        vm.param = {
            type: null
        };
        vm.saveProvider = saveChanges;
        vm.closeModal = onCloseModal;
        vm.types = [
            { name: 'Ship2Anywhere' },
            { name: 'FreightInsure' }
        ]
        init()

        function init() {
            vm.companyId = $rootScope.GlobalProfile.company.id;

            vm.param = angular.copy(provider);
            if (provider) {
                vm.param.status = provider.status.status;
                vm.param.type = { name: 'FreightInsure' }
            } else {
                // vm.param.type = { name: 'FreightInsure' }
            }

        }

        function createNewprovider() {
            const payload = cleanPayload()
            TransitWarrantyService.providers.createNewProvider(
                res => {
                    toastr.success('Successfully Update');
                    vm.isSaving = false;
                    onCloseModal();
                },
                err => {
                    toastr.error(err.message);
                    vm.isSaving = false
                }, payload
            )
        }

        function saveChanges() {
            vm.isSaving = true;
            if (vm.param.id) {
                updateProvider();
            } else {
                createNewprovider();
            }
        }

        function updateProvider() {
            const payload = cleanPayload()
            TransitWarrantyService.providers.updateProvider(
                res => {
                    toastr.success('Successfully Update');
                    vm.isSaving = false;
                    onCloseModal();
                },
                err => {
                    toastr.error(err.message);
                    vm.isSaving = false
                }, payload
            )
        }

        function cleanPayload() {
            const payload = {
                key: vm.param.key,
                name: vm.param.name,
                secret: vm.param.secret,
                type: vm.param.type.name,
                status: vm.param.status,
                userId: 0
            };
            if (vm.param.id) {
                payload.id = vm.param.id
            }

            return payload
        }

        function onCloseModal() {
            $uibModalInstance.close();
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/transit-warranty/modal/TransitWarrantyProviderDetailsModal.js